// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__2PoqF","text":"Dropdown_text__1pyyV","menuItem":"Dropdown_menuItem__2wvoh","content":"Dropdown_content__3Lv-K","arrow":"Dropdown_arrow__3zmjx"};